import { Link } from "@tanstack/react-router";
import { Phone, MapPin, Mail, Clock, Facebook } from "lucide-react";
import { SITE, SERVICES, CITIES } from "@/lib/site";
import mlcLogo from "@/assets/mlc-logo.png.asset.json";



export function Footer() {
  return (
    <footer className="border-t border-border bg-[#000f20] mt-24">
      <div className="container-x py-16 grid gap-12 lg:grid-cols-4">
        <div>
          <img src={mlcLogo.url} alt={`${SITE.name} logo`} className="h-16 w-auto bg-white/95 rounded-md p-2" />
          <p className="mt-4 text-sm text-muted-foreground max-w-xs">{SITE.tagline}</p>

          <p className="mt-6 text-sm text-muted-foreground">
            Premium epoxy and polyaspartic floor coatings throughout Calgary and surrounding areas.
          </p>

          <a
            href={SITE.social.facebook}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 inline-flex items-center gap-2 text-sm text-silver hover:text-copper transition-colors"
          >
            <Facebook className="h-5 w-5" />
            <span>Follow us on Facebook</span>
          </a>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-widest text-copper">Services</p>
          <ul className="mt-4 space-y-2 text-sm">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link to={`/services/${s.slug}` as string} className="text-silver hover:text-copper">{s.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-widest text-copper">Service Areas</p>
          <ul className="mt-4 grid grid-cols-2 gap-y-2 text-sm">
            {CITIES.map((c) => (
              <li key={c.slug}>
                <Link to={`/service-areas/${c.slug}` as string} className="text-silver hover:text-copper">
                  {c.name}, {c.state}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-widest text-copper">Contact</p>
          <ul className="mt-4 space-y-3 text-sm text-silver">
            <li className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 text-copper" />
              {SITE.address.street}, {SITE.address.city}, {SITE.address.region} {SITE.address.postal}
            </li>
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-copper" />
              <a href={SITE.phoneHref} className="hover:text-copper">{SITE.phone}</a>
            </li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-copper" />
              <a href={`mailto:${SITE.email}`} className="hover:text-copper">{SITE.email}</a>
            </li>
            <li className="flex items-center gap-2"><Clock className="h-4 w-4 text-copper" /> {SITE.hours}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="container-x py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} {SITE.name}. All rights reserved. Fully insured & locally owned.</p>
          <div className="flex gap-5">
            <Link to="/contact" className="hover:text-copper">Contact</Link>
            <Link to="/faqs" className="hover:text-copper">FAQs</Link>
            <Link to="/privacy-policy" className="hover:text-copper">Privacy Policy</Link>
            <Link to="/terms-of-service" className="hover:text-copper">Terms of Service</Link>
            <Link to="/quote" className="hover:text-copper">Get a Quote</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
